import React from "react";
import Icon from "../../../components/AppIcon";
import Select from "../../../components/ui/Select";

const ElectricalLogisticsForm = ({ surveyData, errors, onChange }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  const internetStatusOptions = [
    { value: "WiFi", label: "WiFi" },
    { value: "SIM", label: "SIM" },
    { value: "None", label: "None" },
  ];

  const earthingSoilTypeOptions = [
    { value: "Soil Available", label: "Soil Available" },
    { value: "Concrete Floor", label: "Concrete Floor" },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center">
          <Icon name="Zap" size={20} className="text-secondary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Electrical & Site Logistics
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Select
          label="Meter Location"
          placeholder="Select meter location"
          options={[
            { value: "Inside House", label: "Inside House" },
            { value: "Outside Wall", label: "Outside Wall" },
            { value: "Compound Wall", label: "Compound Wall" },
            { value: "Pole", label: "Pole" },
          ]}
          value={surveyData.meterLocation}
          onChange={handleChange.bind(null, "meterLocation")}
          error={errors.meterLocation}
          searchable
        />

        <Select
          label="Internet Status"
          placeholder="Select internet status"
          options={internetStatusOptions}
          value={surveyData.internetStatus}
          onChange={handleChange.bind(null, "internetStatus")}
          error={errors.internetStatus}
          searchable
        />

        <Select
          label="Earthing Soil Type"
          placeholder="Select earthing soil type"
          options={earthingSoilTypeOptions}
          value={surveyData.earthingSoilType}
          onChange={handleChange.bind(null, "earthingSoilType")}
          error={errors.earthingSoilType}
          searchable
        />
      </div>
    </div>
  );
};

export default ElectricalLogisticsForm;
